import { Button } from '../../Button'
import { Tooltip } from '../../Tooltip/Tooltip'
import { ButtonProps } from '../../Button/Types'
import { Plus } from 'blaze-ui/icons'

interface AddViewerButtonProps {
  onPress: ButtonProps['onPress']
}

export const AddViewerButton = ({ onPress }: AddViewerButtonProps) => (
  <Tooltip label="Keep this person informed on the status of the review process." placement="top">
    <div>
      <Button onPress={onPress} frontIcon={Plus} size="md" variant="tertiary">
        Viewer
      </Button>
    </div>
  </Tooltip>
)
